export const TITLE_THREE = 'Новая оценка выполнения и удовлетворенности';
export const ASSESSMENT = 'Оценка 1';
export const GOAL_TITLE = 'Цель и ее достижение';
export const GOAL = 'Цель';
export const PLACEHOLDER_GOAL = 'Опишите цель';
export const EXAMPLE_GOAL =
	'Пример: «Через 2 месяца Петя может сидеть на стуле со спущенными ногами в течение 10 минут, пока мама надевает на него футболку и кофту';
export const GOAL_PLAN = 'Краткий план достижения цели';
export const STEPS_PLAN = 'Опишите последовательность действий в несколько шагов';
export const FINAL_SAVE = 'Сохранить';
export const EVALUATE_ACTIVITY =
	'Попросите клиента оценить каждую «проблемную» активность с точки зрения ее выполнения';
export const SCALE = 'по 10-бальной шкале, где 1 - совсем не получается, 10 - отлично получается';
export const HINTS_QUESTIONS = 'Укажите цель одним предложением, отвечая на вопросы:';
export const ACHIEVEMENTS = 'Что конкретно необходимо достичь/сделать?';
export const RESULT = 'Как будет оценен результат?';
export const DEADLINES = 'В какие сроки цель должна быть достигнута?';
export const DOING = 'Выполнение (от 1 до 10)';
export const SATISFACTION = 'Удовлетворенность (от 1 до 10)';
export const PREFICS = 'Префикс';
export const DOMEN = 'Домен (4х-значный код)';
export const CHOOSE = 'Выберите';
export const MKF = 'МКФ-код';
export const HINTS = 'Подсказки';
export const CANCEL = 'Отменить';
export const DATA_INTERVIEW = 'Планируемая дата следующего интервью';
